import imagesLoaded from 'imagesloaded';
import { store } from './store';
import { setHeaderState } from './helpers';

export const resizeHeader = () => {
  const resizeBtn = document.querySelector('.resize-btn');
  const html = document.documentElement;

  if (!resizeBtn) {
    return;
  }

  const headerState = localStorage.getItem('header-state');

  if (headerState === 'resize') {
    resizeBtn.setAttribute('aria-expanded', true);
  } else {
    resizeBtn.setAttribute('aria-expanded', false);
  }

  resizeBtn.addEventListener('click', () => {
    const postsWrapper = document.querySelector('.main-content__posts');

    if (html.getAttribute('header-state') == 'resize') {
      setHeaderState('no-resize');
      html.setAttribute('header-state', 'no-resize');
      resizeBtn.setAttribute('aria-expanded', false);
    } else {
      setHeaderState('resize');
      html.setAttribute('header-state', 'resize');
      resizeBtn.setAttribute('aria-expanded', true);
    }

    if (postsWrapper) {
      imagesLoaded(postsWrapper, () => {
        store.postsGrid.layout();
      });
    }
  });
};
